import { Frame } from '../Frame';

type EmbedProps = {
  attrs: {
    href: string;
  };
};

const YOUTUBE_URL_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?(?:youtube(?:-nocookie)?\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:\/|[?&].*)?$/i;

const extractTimestamp = (href: string) => {
  try {
    const url = new URL(href);
    const t = url.searchParams.get('t');
    if (!t) return null;

    const seconds = parseInt(t, 10);

    return Number.isNaN(seconds) ? null : seconds;
  } catch (error) {
    return null;
  }
};

export const YouTube = (props: EmbedProps): string | null => {
  const extractVideoId = (href: string) => {
    const match = href.match(YOUTUBE_URL_REGEX);

    return match ? match[1] : null;
  };
  const videoId = extractVideoId(props.attrs.href);
  if (!videoId) {
    return null;
  }

  const timestamp = extractTimestamp(props.attrs.href);
  const embedUrl = `https://www.youtube.com/embed/${videoId}?modestbranding=1${
    timestamp ? `&start=${timestamp}` : ''
  }`;

  return Frame({
    src: embedUrl,
    title: `YouTube Embed (${videoId})`,
  });
};

// Add the isMatch function for YouTube
YouTube.isMatch = (href: string): boolean => {
  return YOUTUBE_URL_REGEX.test(href);
};
